import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin, Github, Compass } from 'lucide-react';

const PHONE = '+353 85 862 5500';
const PHONE_HREF = 'tel:+353858625500';

const Footer = () => {
  const year = new Date().getFullYear();

  const links = {
    Services: [
      { name: 'Digital Transformation', href: '/#services' },
      { name: 'AI Implementation', href: '/#services' },
      { name: 'Custom Development', href: '/#services' },
      { name: 'QA Consultancy', href: '/#services' },
    ],
    Products: [
      { name: 'QE Navigator', href: '/navigator', highlight: true },
    ],
    Company: [
      { name: 'About Us', href: '/#about' },
      { name: 'Client Results', href: '/#stories' },
      { name: 'Blog', href: '/blog' },
      { name: 'Contact', href: '/#contact' },
    ],
  };

  return (
    <footer className="relative border-t" style={{ borderColor: 'rgba(0,212,255,0.1)', background: 'rgba(8,13,26,0.98)' }}>
      <div className="absolute inset-0 grid-pattern opacity-5" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img src="/logo.png" alt="IronGate" className="w-10 h-10 object-contain" onError={e => e.target.style.display = 'none'} />
              <div>
                <h3 className="text-xl font-bold gradient-text tracking-tight">IronGate</h3>
                <p className="text-[10px] text-gray-600 tracking-widest uppercase">Software Ltd</p>
              </div>
            </div>
            <p className="text-sm text-gray-500 mb-6 max-w-xs leading-relaxed">
              Digital transformation, AI implementation, and custom software development — backed by 15 years of enterprise expertise.
            </p>
            <div className="space-y-2.5">
              <a href="mailto:contact@irongate.ie"
                className="flex items-center space-x-2 text-gray-500 hover:text-cyan-400 transition-colors">
                <Mail className="w-3.5 h-3.5" />
                <span className="text-sm">contact@irongate.ie</span>
              </a>
              <a href={PHONE_HREF}
                className="flex items-center space-x-2 text-gray-500 hover:text-cyan-400 transition-colors">
                <Phone className="w-3.5 h-3.5" />
                <span className="text-sm">{PHONE}</span>
              </a>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(links).map(([col, items]) => (
            <div key={col}>
              <h4 className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-4">{col}</h4>
              <ul className="space-y-2.5">
                {items.map((link, i) => (
                  <li key={i}>
                    {link.href.startsWith('/') && !link.href.startsWith('/#') ? (
                      <Link
                        to={link.href}
                        className="text-sm transition-colors flex items-center space-x-1.5"
                        style={{ color: link.highlight ? '#00d4ff' : undefined }}
                        onMouseEnter={e => e.currentTarget.style.color = '#00d4ff'}
                        onMouseLeave={e => e.currentTarget.style.color = link.highlight ? '#00d4ff' : '#6b7280'}
                      >
                        {link.highlight && <Compass className="w-3 h-3" />}
                        <span>{link.name}</span>
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-sm text-gray-500 hover:text-cyan-400 transition-colors"
                      >
                        {link.name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t pt-8 flex flex-col md:flex-row items-center justify-between gap-4"
          style={{ borderColor: 'rgba(255,255,255,0.06)' }}>
          <p className="text-xs text-gray-600">© {year} IronGate Software LTD. All rights reserved.</p>

          <div className="flex items-center space-x-3">
            <a href="https://www.linkedin.com/in/ionut-apostu/" target="_blank" rel="noopener noreferrer"
              className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-500 hover:text-cyan-400 transition-all"
              style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
              <Linkedin className="w-3.5 h-3.5" />
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer"
              className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-500 hover:text-cyan-400 transition-all"
              style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}>
              <Github className="w-3.5 h-3.5" />
            </a>
          </div>

          <div className="flex items-center space-x-5 text-xs text-gray-600">
            <Link to="/privacy" className="hover:text-gray-400 transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-gray-400 transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
